import React from 'react';
import { Link } from 'react-router-dom';

import './Footer.scss';
import NewsletterForm from '../NewsletterForm';

const imgURL = process.env.REACT_APP_CLOUDFRONT_URL;
const foosPage = process.env.REACT_APP_CODESPARK_BASE_URL;
const accountsPage = process.env.REACT_APP_ACCOUNTS_BASE_URL;
const dashboardPage = process.env.REACT_APP_DASHBOARD_BASE_URL;

const Footer = props => (
  <div>

      <div className="small-12 cell foos-newsletter">
        <h1>Sign up to receive updates on codeSpark Academy!</h1>
        <NewsletterForm />
      </div>
      <div className="footer-container">
        <div className="footer-content grid-x grid-margin-x align-spaced">
          <div className="card-container small-12 medium-3">
            <div className="contact-card grid-x grid-padding-x align-center">
              <div className="logo-footer small-12">
                <img src={`${imgURL}/global/logo/codeSpark_partof_Homer_white2.svg`} alt="codeSpark Academy" />
              </div>
              <p className="content-blurb small-12">
                Preparing kids everywhere with the skills they’ll need for the world of tomorrow.
              </p>
              <div>
                <ul className="social-links small-12">
                  <li>
                    <a href="https://www.facebook.com/pages/codeSpark/151949611657987?ref=br_tf" target="_blank" rel="noopener noreferrer">
                      <img src={`${imgURL}/global/icons/facebook_footer_icon.svg`} alt="Facebook social link" />
                    </a>
                  </li>
                  <li>
                    <a href="http://twitter.com/codesparkapp" target="_blank" rel="noopener noreferrer">
                      <img src={`${imgURL}/global/icons/twitter_footer_icon.svg`} alt="Twitter social link" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/codesparkapp/" target="_blank" rel="noopener noreferrer">
                      <img src={`${imgURL}/global/icons/instagram_footer_icon.svg`} alt="Instagram social link" />
                    </a>
                  </li>
                </ul>
              </div>
              <div className="app-store-badges">
                <a
                  className="apple"
                  href="https://itunes.apple.com/us/app/codespark-academy-foos-coding/id923441570?mt=8"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-event-category="app-download"
                  data-event-action="global-footer"
                  data-event-label="ios"
                >
                  <img src={`${imgURL}/global/icons/apple_store_button.svg`} alt="Apple app store link" />
                </a>
                <a
                  className="google"
                  href="http://play.google.com/store/apps/details?id=org.codespark.thefoos&utm_source=global_co&utm_medium=prtnr&utm_content=Mar2515&utm_campaign=PartBadge&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-event-category="app-download"
                  data-event-action="global-footer"
                  data-event-label="android-google"
                >
                  <img src={`${imgURL}/global/icons/google_store_button.svg`} alt="Google play link" />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-menu small-12 medium-3">
            <ul>
              <h5>FOR PARENTS</h5>
              <li>
                <a href={`${foosPage}/how-it-works`}>How it Works</a>
              </li>
              <li>
                <a href={`${foosPage}/frequently-asked-questions`}>FAQ</a>
              </li>
              <li>
                <a href={process.env.REACT_APP_SIGNUP_BASE_URL}>Start a Free Trial</a>
              </li>
              <li>
                <a href={`${accountsPage}/gift`} target="_blank" rel="noopener noreferrer">Buy a Gift</a>
              </li>
              <li>
                <a href={`${accountsPage}/promo`}>Redeem a Gift</a>
              </li>
              <li>
                <a href={`${accountsPage}/login`}>Login</a>
              </li>
            </ul>
          </div>
          <div className="footer-menu small-12 medium-3">
            <ul>
              <h5>FOR EDUCATORS</h5>
              <li>
                <a href={`${foosPage}/educators`}>Educator Resources</a>
              </li>
              <li>
                <a href={`${foosPage}/hour-of-code`}>Hour of Code</a>
              </li>
              <li>
                <a href={dashboardPage} target="_blank" rel="noopener noreferrer">Educator Login</a>
              </li>
              <li>
                <a href="https://teach.codespark.com/courses/codespark-ignite">Professional Development</a>
              </li>
            </ul>
            <ul>
              <h5>PARTNERS</h5>
              <li>
                <a href={`${foosPage}/girl-scouts`}>Girl Scouts</a>
              </li>
              <li>
                <a href="https://codeninjas.codespark.com/login" target="_blank" rel="noopener noreferrer">Code Ninjas</a>
              </li>
              <li>
                <a href="https://app.impact.com/campaign-promo-signup/codeSpark1614190230174.brand?execution=e12s1" target="_blank" rel="noopener noreferrer">Affiliates</a>
              </li>
              <li>
                <a href={`${foosPage}/employee-benefits-codespark-teams`}>Employee Benefits</a>
              </li>
            </ul>
          </div>
          <div className="footer-menu small-12 medium-3">
            <ul>
              <h5>CODESPARK</h5>
              <li>
                <a href={`${foosPage}/about`}>About Us</a>
              </li>
              <li>
                <a href="/posts/codespark-academy-award-winning-coding-app" target="_blank" rel="noopener noreferrer">Awards</a>
              </li>
              <li>
                <a href={`${foosPage}/press`}>Press</a>
              </li>
              <li>
                <a href={`${foosPage}/contact`}>Contact Us</a>
              </li>
              <li>
                <a href="https://shop.codespark.com/" target="_blank" rel="noopener noreferrer">The Foo Store</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-crumb grid-x grid-padding-x">
          <div className="copyright small-12 medium-3"><b>&copy; codeSpark { new Date().getFullYear() }</b></div>
          <div className="terms small-12 medium-1">
            <Link to="Terms">Terms</Link>
          </div>
          <div className="privacy small-12 medium-1">
            <Link to="Privacy">Privacy</Link>
          </div>
          <div className="small-12 medium-3">
            <Link to="Privacy" hash="ccpa">Do Not Sell My Personal Information</Link>
          </div>
          <div className="compliance small-12 medium-4">Updated for CCPA compliance effective Jan 1, 2020</div>
        </div>
      </div>
  </div>
);

export default Footer;
